import { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Image, Button, Form, FormControl, InputGroup } from "react-bootstrap";
import { MESSAGE } from '../../../utils/message';
import Search_icon from "../../../assests/images/search-icon.svg";
import Pincode_pin_icon from "../../../assests/images/search-pincode-pin.svg";
import { useFormik } from "formik";
import {
    SerchBox,
    InputGroupIcon,
} from "./searchBoxStyle";
import { useNavigate } from "react-router-dom";
import 'react-autocomplete-input/dist/bundle.css';
import AutosuggestSearch from "../autoSuggestSearch";

const SearchBox = () => {
    const [searchVal, setSearchVal] = useState('')
    const [locationSlug, setLocationSlug] = useState('');


    const navigate = useNavigate();
    const formik = useFormik({
        initialValues: {
            zipcode: "",
        },
        onSubmit: (values, { resetForm }) => {
            if (searchVal && values.zipcode) {
                // Navigate using both keyword and zipcode
                navigate(`/organizations/browse/search:${searchVal}/zipcode/${values.zipcode}`);
            }
            else if (values.zipcode) {
                navigate(`${locationSlug}/zipcode/${values.zipcode}`)
            }
            else if (parseInt(values.zipcode)) {
                navigate(`/zipcode/${values.zipcode}`);
            } else {
                if (searchVal) {
                    typeof localStorage !== "undefined" && localStorage.setItem("search", searchVal)
                    navigate(`/organizations/browse/search:` + searchVal);
                } else {
                    typeof localStorage !== "undefined" && localStorage.removeItem("search")
                    navigate(`/organizations/browse`);
                }
            }
            resetForm({});
            setSearchVal('');
        },
    });
    return (
        <SerchBox>
            <Form className="search-header" onSubmit={formik.handleSubmit}>
                <InputGroup>
                    <Button className="btn p-0 m-0 bg-transparent border-0 outline-none" type="submit">
                        <InputGroupIcon>
                            <Image src={Search_icon} width="20px" height="20px" className="search-group-icon" />
                        </InputGroupIcon>
                    </Button>
                    <AutosuggestSearch

                        searchValue={searchVal}
                        setSearchValue={setSearchVal}
                        searchSlug={locationSlug}
                        setSearchSlug={setLocationSlug}
                        setZipCodeVal={undefined}
                        zipCodeVal={undefined}
                    />

                </InputGroup>
                <InputGroup>
                    <InputGroupIcon>
                        <Image src={Pincode_pin_icon} width="20px" height="20px" className="search-group-icon" />
                    </InputGroupIcon>
                    <FormControl
                        type="number"
                        placeholder="Zip Code"
                        onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                        maxLength={10}
                        name="zipcode"
                        value={formik.values.zipcode}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className="zip-code-box"
                    />
                </InputGroup>
                <Button variant="outline-success-blue" type="submit">{MESSAGE.search}</Button>
            </Form>
        </SerchBox>
    );
};

export default SearchBox;
